import { render, staticRenderFns } from "./TabelaIndicadores.vue?vue&type=template&id=1ee99b1e&scoped=true"
import script from "./TabelaIndicadores.vue?vue&type=script&lang=js"
export * from "./TabelaIndicadores.vue?vue&type=script&lang=js"
import style0 from "./TabelaIndicadores.vue?vue&type=style&index=0&id=1ee99b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee99b1e",
  null
  
)

export default component.exports